<template>
  <div class="home-wrapper">
    <div class="box">
      <!-- <img src="../../assets/right.png" class="pic" /> -->
      <img src="https://aweqn.zhiandexpo.com/success2027.png" alt="pic">
      <div class="succ">代报名成功，详情可查看代报名记录</div>
      <div class="btns">
        <el-button
          round
          type="primary"
          size="medium"
          class="btn"
          @click="goAgent"
          >继续代报名</el-button
        >
        <el-button
          round
          type="primary"
          size="medium"
          plain
          class="btn btn1"
          @click="returnHome"
          >返回首页</el-button
        >
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="close"
      :close-on-press-escape="close"
      :show-close="close"
      :visible.sync="pop"
      width="628px"
    >
      <div class="title">
        请选择您的入场时间
        <span class="stitle">（*蓝色加粗数字为可预约余量）</span>
      </div>
      <div class="timeList">
        <div v-for="(item, index) in keyList" :key="index" class="item">
          <div class="time">
            {{ item.split("-")[1] + "月" + item.split("-")[2] + "日" }}
          </div>
          <div class="checkBox">
            <div
              v-for="(itm, idx) in dateList[item]"
              :key="idx"
              class="checkItem"
              :class="ids.find((e) => e == itm.id) ? 'checked' : ''"
              @click="clickId(item, idx)"
            >
              <div class="item-top">
                <div class="code">
                  {{ itm.code }}
                </div>
                <div class="sd">
                  {{ itm.time == 1 ? "上午" : "下午" }}
                </div>
              </div>
              <div class="item-mid">
                {{ itm.time == 1 ? "8:00-12:00" : "13:00-17:00" }}
              </div>
              <div class="item-btm">
                {{ itm.left_count }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="layer-btn" class="btn">
        <div class="submit" @click="submit">确认</div>
        <div class="cancel" @click="cancel">暂不选择</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getEnterTime, userReservation, checkEnterTime } from "../../api/data";

export default {
  data() {
    return {
      info: {},
      apply_type: 1,
      pop: false,
      close: false,
      dateList: [],
      keyList: [],
      ids: [],
      timeList: [],
    };
  },
  mounted() {
    this.apply_type = this.$route.params.apply_type;
    this.getTime();
    this.getUserTime();
  },
  methods: {
    returnHome() {
      window.location.href = "https://www.awe.com.cn";
    },
    goAgent() {
      this.$router.go(-1);
      // let mobile = this.mobile
      //   uni.redirectTo({
      //   	url: `/pages/agent/agent?mobile=${mobile}`,
      //   })
    },
    getTime() {
      getEnterTime().then((res) => {
        if (res.code == 0) {
          this.dateList = res.data.reduce(
            (r, x) => ((r[x.date] || (r[x.date] = [])).push(x), r),
            {}
          );
          var key = [];
          res.data.map((item) => {
            key.push(item.date);
          });
          for (var i = 0; i < key.length; i++) {
            if (this.keyList.indexOf(key[i]) === -1) {
              this.keyList.push(key[i]);
            }
          }
        }
      });
    },
    getUserTime() {
      userReservation({ mobile: this.$route.query.mobile }).then((res) => {
        if (res.code == 0) {
          this.ids = [];
          this.timeList = res.data;

          res.data.map((item) => {
            this.ids.push(item.id);
          });
        }
      });
    },
    clickId(item, idx) {
      this.ids.indexOf(this.dateList[item][idx].id);
      if (this.ids.indexOf(this.dateList[item][idx].id) > -1) {
        this.ids.splice(this.ids.indexOf(this.dateList[item][idx].id), 1);
      } else {
        this.ids.push(this.dateList[item][idx].id);
      }
    },
    cancel() {
      this.pop = false;
      this.getUserTime();
    },
    submit() {
      const data = { ids: this.ids };
      if (this.mobile != "") {
        data.mobile = this.$route.query.mobile;
      }
      checkEnterTime(data).then((res) => {
        if (res.code === 0) {
          this.pop = false;
          this.getUserTime();
        }
      });
    },
  },
  // created() {
  //   let u = navigator.userAgent;
  //   if (u.indexOf("iPhone") > -1) {
  //     inobounce.enable();
  //   }
  // },
  // beforeDestroy() {
  //   inobounce.disable();
  // },
};
</script>



<style scoped>
.home-wrapper {
  width: 100%;
  height: 100%;
  background: url("https://aweqn.zhiandexpo.com/awe2027pc.jpg") no-repeat;
  background-size: contain;
  padding-top: 400px;
  padding-bottom: 200px;
}
.box {
  width: 1200px;
  /* height: 820px; */
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px rgba(0, 0, 0, 0.24);
  border-radius: 27px;
  margin: 0 auto;
  padding: 85px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pic {
  width: 196px;
  height: 146px;
}
.succ {
  font-size: 16px;
  padding: 40px 0 100px;
}
.btn {
  width: 256px;
  margin: 0 30px;
}
.title {
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
.stitle {
  font-size: 12px;
  color: #1C519A;
  font-weight: 400;
}
.timeList {
  display: flex;
  flex-wrap: wrap;
}
.item {
  width: 118px;
  /* margin-bottom: 20px;
  margin-right: 24px; */
  margin: 20px 24px 20px 0;
}
.time {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 16px;
}
.checkBox {
  width: 118px;
  height: 204px;
}
.checkItem {
  width: 118px;
  height: 82px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #999;
  font-size: 14px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}

.checked {
  border: 1px solid #1C519A;
  color: #333333;
}
.item-top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-btm {
  color: #1C519A;
}
.code {
  font-weight: 500;
  margin-right: 4px;
}
#layer-btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.submit {
  cursor: pointer;
  width: 190px;
  height: 32px;
  background: #1C519A;
  border-radius: 17px;
  border: 1px solid #1C519A;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #fff;
}
.cancel {
  cursor: pointer;
  width: 190px;
  height: 32px;
  border-radius: 17px;
  border: 1px solid #1C519A;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #1C519A;
  margin-top: 13px;
}

.btns /deep/ .el-button--primary.is-plain {
  color: #1C519A;
  background-color: rgba(0,160,107, 0.24);
  border-color: rgba(0,160,107, 0.6);
}
.btns /deep/ .el-button--primary:hover {
  background: #1C519A;
  border-color: rgba(0,160,107, 0.6);
}

.btns /deep/ .btn1:hover {
    background-color: rgba(0, 160, 107, 0.24);
    border-color: rgba(0, 160, 107, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/views/home/agent-done.vue